import React from "react";
import { Link } from "react-router-dom";

const getSupportColumns = (deleteFunc, navigate) => [
  {
    title: "S.No",
    dataIndex: "id",
    render: (text, record, index) => index + 1,
    sorter: (a, b) => a.id.length - b.id.length,
    width: "5%",
  },
  {
    title: "Title",
    dataIndex: "name",
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    width: "20%",
  },
  {
    title: "Phone Number",
    dataIndex: "phoneNumber",
    width: "15%",
  },
  {
    title: "Query",
    dataIndex: "query",
    width: "20%",
  },
  {
    title: "Ticket Status",
    dataIndex: "ticketStatus",
    width: "10%",
  },
  {
    title: "Action",
    render: (_, record) => (
      <div className="dropdown dropdown-action text-end">
        <Link
          to="#"
          className="action-icon dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          <i className="material-icons">more_vert</i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
          <Link className="dropdown-item" to={`/addSupport/${record.id}`}>
            <i className="fa fa-pencil m-r-5" /> Edit
          </Link>
          <button
            className="dropdown-item"
            onClick={() => deleteFunc(record.id)}
          >
            <i className="fa fa-trash m-r-5" /> Delete
          </button>
        </div>
      </div>
    ),
    width: "10%",
  },
];

export default getSupportColumns;
